import { render, staticRenderFns } from "./LiveImport.vue?vue&type=template&id=2a760f34&"
import script from "./LiveImport.vue?vue&type=script&lang=js&"
export * from "./LiveImport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports